import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const names = ['Mateo', 'Valentina', 'Santiago', 'Sofía', 'Matías', 'Camila', 'Lucas', 'Martina', 'Joaquín', 'Lucía', 'Nicolás', 'María', 'Tomás', 'Paula', 'Facundo', 'Florencia', 'Agustín', 'Micaela', 'Lautaro', 'Julieta'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Santiago del Estero', 'Corrientes', 'Posadas', 'Montevideo', 'Santiago', 'Bogotá', 'Lima', 'CDMX'];
export const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Show for 4 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showPopup();
      // Then set interval for subsequent popups (every 15-20 seconds)
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 5000) + 15000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-367">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 max-w-sm bg-white border border-neutral-200 rounded-xl shadow-lg p-4 flex items-start gap-4" data-id="element-368">
          <div className="bg-brand-50 rounded-full p-2 flex-shrink-0 mt-1" data-id="element-369">
            <CheckCircle2 className="w-5 h-5 text-brand-600" data-id="element-370" />
          </div>
          <div data-id="element-371">
            <p className="text-sm text-neutral-700" data-id="element-372">
              <strong className="text-neutral-900" data-id="element-373">
                {currentPurchase.name}
              </strong>{' '}
              de {currentPurchase.city} acaba de comprar
            </p>
            <p className="text-xs font-bold text-brand-600 mt-1" data-id="element-374">
              CAJA DE COBRO
            </p>
            <p className="text-[10px] text-neutral-500 mt-2" data-id="element-375">
              Hace unos minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};